import axios from 'axios';
import URLS from '../util/urls.js';

const state = {
  indiceSelecionado: 'mapa',
  imoveis: [],
}

const mutations = {
  atualizarIndiceSelecionado(state, payload) {
    state.indiceSelecionado = payload;
  },
  atualizarImoveis(state, payload) {
    state.imoveis = payload;
  },
  atualizarImoveisCaptados(state, payload) {
    state.imoveisCaptados = payload;
  },
  atualizarImoveisVendidos(state, payload) {
    state.imoveisVendidos = payload;
  },
  atualizarImoveisComFoto(state, payload) {
    state.imoveisComFoto = payload;
  },
  atualizarImoveisSemFoto(state, payload) {
    state.imoveisSemFoto = payload;
  },
  atualizarImoveisComLocalizacao(state, payload) {
    state.imoveisComLocalizacao = payload;
  },
  atualizarImoveisSemLocalizacao(state, payload) {
    state.imoveisSemLocalizacao = payload;
  },
}

const actions = {
  atualizarIndiceSelecionado(context, payload) {
    context.commit('atualizarIndiceSelecionado', payload);
  },

  // MAPA
  recuperarImoveisMapa(context) {
    return axios.get(URLS.DASHBOARD_LISTAR_IMOVEIS_MAPA)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImoveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarImoveisMapa');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  // DASHBOARD DE VENDA
  recuperarImoveisCaptados(context) {
    return axios.get(URLS.DASHBOARD_IMOVEIS_CAPTADOS)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImoveisCaptados', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarImoveisCaptados');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarImoveisVendidos(context) {
    return axios.get(URLS.DASHBOARD_IMOVEIS_VENDIDOS)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImoveisVendidos', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarImoveisVendidos');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  listarImoveisCaptadosVendidos(context) {
    return axios.get(URLS.DASHBOARD_LISTAR_IMOVEIS_CAPTADOS_VENDIDOS_GRAFICO)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarImoveisCaptadosVendidos');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  recuperarSumarioTipoImovel(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_SUMARIO_TIPO_IMOVEL)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarSumarioTipoImovel');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarSumarioStatus(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_SUMARIO_STATUS)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarSumarioStatus');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarSumarioFotos(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_SUMARIO_FOTOS)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarSumarioFotos');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarSumarioLocalizacao(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_SUMARIO_LOCALIZACAO)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarSumarioLocalizacao');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  // DASHBOARD DE ALUGUEL
  listarImoveisCaptadosAlugados(context) {
    return axios.get(URLS.DASHBOARD_LISTAR_IMOVEIS_CAPTADOS_ALUGADOS_GRAFICO)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarImoveisCaptadosAlugados');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  recuperarSumarioTipoImovelImoveisAluguel(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_SUMARIO_TIPO_IMOVEL_IMOVEIS_ALUGUEL)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarSumarioTipoImovelImoveisAluguel');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarFaixasVacancia(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_VACANCIA_IMOVEIS)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarFaixasVacancia');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarFaixasNegociacao(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_NEGOCIACAO_IMOVEIS)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarFaixasNegociacao');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarSumarioStatusImoveisAluguel(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_SUMARIO_STATUS_IMOVEIS_ALUGUEL)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarSumarioStatusImoveisAluguel');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarQuantidadeAlugueisAtrasadosPorStatus(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_QUANTIDADE_ALUGUEIS_ATRASADOS)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarQuantidadeAlugueisAtrasadosPorStatus');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarQuantidadeBoletosAvulsos(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_QUANTIDADE_BOLETOS_AVULSOS)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarQuantidadeBoletosAvulsos');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarQuantidadeBoletosAcordo(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_QUANTIDADE_BOLETOS_ACORDO)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarQuantidadeBoletosAcordo');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarSumarioLocatariosInadiplentesAluguel(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_SUMARIO_LOCATARIOS_INADIPLENTES)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarSumarioLocatariosInadiplentesAluguel');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarSumarioReceitaAluguelMes(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_SUMARIO_RECEITA_ALUGUEL_MES)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarSumarioReceitaAluguelMes');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarGestaoAluguelMesAtual(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_GESTAO_ALUGUEL_MES_ATUAL)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarGestaoAluguelMesAtual');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarSumarioFotosImoveisAluguel(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_SUMARIO_FOTOS_IMOVEIS_ALUGUEL)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarSumarioFotosImoveisAluguel');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarSumarioLocalizacaoImoveisAluguel(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_SUMARIO_LOCALIZACAO_IMOVEIS_ALUGUEL)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarSumarioLocalizacaoImoveisAluguel');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  // ATENDIMENTOS
  listarAtendimentos(context) {
    return axios.get(URLS.DASHBOARD_LISTAR_ATENDIMENTOS_GRAFICO)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarAtendimentos');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  recuperarSumarioAtendimento(context) {
    return axios.get(URLS.DASHBOARD_RECUPERAR_SUMARIO_ATENDIMENTO)
    .then((response) => {
      switch(response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarSumarioAtendimento');
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarDesempenhoLocacao(context) {
    return axios.post(URLS.DASHBOARD_RECUPERAR_DESEMPENHO_LOCACAO)
    .then((response) => {
      switch (response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarDesempenhoLocacao');
            }
          }).catch((error) => {
            throw error;
          })
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  recuperarVistoriasNoMes(context) {
    return axios.post(URLS.DASHBOARD_RECUPERAR_VISTORIAS_NO_MES)
    .then((response) => {
      switch (response.data.status) {
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarVistoriasNoMes');
            }
          }).catch((error) => {
            throw error;
          })
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}